import {Spin} from 'antd';
import React, {useMemo} from 'react';

import {ReactComponent as UploadFail} from 'shared/assets/fail.svg';
import {ReactComponent as UploadSuccess} from 'shared/assets/success.svg';
import {EFileUploadStatus} from 'store/slices/documents-uploading-slice';

import './progress-cell.less';

interface IOwnProps {
    percent: number;
    status?: EFileUploadStatus;
}

export const ProgressCell = ({percent, status}: IOwnProps) => {
    const renderNode = useMemo(() => {
        switch (status) {
        case EFileUploadStatus.ACTIVE:
            return <Spin />;
        case EFileUploadStatus.SUCCESS:
            return <UploadSuccess />;
        case EFileUploadStatus.EXCEPTION:
            return <UploadFail />;
        default:
            return undefined;
        }
    }, [status]);

    return (
        <div className="progress-cell">{
            renderNode || (percent === 99 ? <UploadSuccess /> : `${percent}%`)
        }
        </div>
    );
};
